export default __webpack_public_path__ + "static/media/9-1.35d5f233.gif";